import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for phone number validation.</blockquote>
 * 
 * Patterns used to validate phone number formats.
 */
export const PHONE_PATTERNS = {
  /**
   * Validates phone numbers with digits, spaces, hyphens, parentheses, dots, and plus signs
   * Allows various formatting styles: (123) 456-7890, 123-456-7890, +1 123 456 7890, etc.
   */
  PHONE_NUMBER: {
    regex: /^[\d\s\-\(\)\.\+]+$/,
    description: 'Validates phone numbers with digits, spaces, hyphens, parentheses, dots, and plus signs',
    examples: ['(123) 456-7890', '123-456-7890', '+1 123 456 7890', '123.456.7890'],
    counterExamples: ['abc123', '123-456-7890x', 'invalid'],
  } as RegexPattern,
} as const;
